module.exports = __webpack_public_path__ + "media/images/logos/ICMJE-wreath-ebd59d89a13abe0a67b9167523c23c0d.png";